document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.tco-container--carousel');
  const bullets = [...document.querySelectorAll('.tco-bullet')];
  const activeClass = 'tco-component--carousel-item--active';
  const bulletActiveClass = 'tco-bullet--active';
  const options = {
    rootMargin: '0px',
    threshold: 0.7
  }

  let slides = '';

  if(carousel) {
    slides = [...carousel.querySelectorAll('.tco-component--carousel-item')];
  }

  if( slides.length < 1 ) {
    return;
  }


  const callback = (entries) => {
    entries.forEach((entry) => {
      const { target } = entry;

      if (entry.intersectionRatio >= 0.7) {
        target.classList.add(activeClass);

        const index = target.getAttribute('data-slide');

        bullets.forEach((bullet) => {
          if (bullet.getAttribute('data-bullet') === index) {
            bullet.classList.add(bulletActiveClass);

          } else {
            bullet.classList.remove(bulletActiveClass);
          }

          bullet.addEventListener('click', function(event) {
            event.preventDefault();
            const selected = bullet.getAttribute('data-bullet');
            const slideAmount = selected - index;
            const slideWidth = target.clientWidth;

            carousel.scrollBy({
              left: slideAmount * slideWidth,
              top: 0,
              behavior: 'smooth'
            });

          });
        })

      } else {
        target.classList.remove(activeClass);
      }
    })
  }

  const observer = new IntersectionObserver(callback, options);

  slides.forEach((slide) => {
    observer.observe(slide);
  })

  const destroyCarousel = () => {
    const vw = window.innerWidth;
    const is_insight = carousel.classList.contains('tco-featured-column--secondary');

    if ( (!is_insight && vw >= 832) || (is_insight && vw >= 1080) ) {
      carousel.removeAttribute('aria-label');
      carousel.removeAttribute('role');
      carousel.removeAttribute('aria-describedby');
      carousel.removeAttribute('tabindex');
    } else {
      carousel.setAttribute('aria-label', 'carousel');
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-describedby', 'focus');
      carousel.setAttribute('tabindex', '0');
    }
  }

  window.addEventListener('resize', destroyCarousel);

})
